/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import GridMap from "./TileGridMap";
import { formatPerc } from "../utils/dataHelpers/formatters";
import Legend from "./TileGridMap/Legend";

class Body extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="body__container">
        <Legend title="Death certificates returned after 13 weeks" />
        <GridMap
          data={data.stateData}
          tooltipValueField="percentage"
          tooltipValueFormatter={formatPerc}
          tooltipLabelField="name"
          colorScaleField="percentage"
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default Body;
